module.exports = __webpack_public_path__ + "img/franco_risotto.97b743d1.png";